export const NEW_ADMIN_REQUESTING = 'newAdmin/NEWADMINREQUESTING';
export const NEW_ADMIN_SUCCESS = 'newAdmin/NEWADMINSUCCESS';
export const NEW_ADMIN_ERROR = 'newAdmin/NEWADMINERROR';
